import { render, staticRenderFns } from "./StockMiniTrend.vue?vue&type=template&id=a7064b4e&scoped=true"
import script from "./StockMiniTrend.vue?vue&type=script&lang=js"
export * from "./StockMiniTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7064b4e",
  null
  
)

export default component.exports